// 这些页面原先没有独立的访问埋点。已有组件埋点的页面不在此重复上报：
// 首页、算法超市/详情、模型转换、AI Playground、UniClaw 首页/文档。
const pagePositions = {
  '/aide': 'aide',
  '/aide/guide': 'aide > guide',
  '/aide/control-panel': 'aide > control-panel',
  '/aide/model-manager': 'aide > model-manager',
  '/aide/model-inference': 'aide > model-inference',
  '/aide/performance': 'aide > performance',
  '/tool': 'aide > tool',
  '/datahub': 'datahub',
  '/omni-train': 'omni_train',
  '/memcore/intro': 'memcore > intro',
  '/uniclaw/flash': 'uniclaw > flash',
  '/uniclaw/auth': 'uniclaw > auth',
}

const memcorePositions = {
  memcoreHome: 'memcore',
  memcoreChat: 'memcore > chat',
  memcoreMemories: 'memcore > memories',
  memcoreMemoryGraph: 'memcore > memory_graph',
}

export function getPageTrackPosition(route) {
  if (!route.matched?.length || route.name === 'not-found') return null
  if (pagePositions[route.path]) return pagePositions[route.path]
  if (memcorePositions[route.name]) return memcorePositions[route.name]
  // 保留旧导航的 core / solution 命名，直接打开页面也能统计。
  if (route.path.startsWith('/core_capabilities/')) return `core > ${route.path.slice(1)}`
  if (route.path.startsWith('/solutions/') ||
      ['massageRobot', 'intelligentSorting', 'voiceAssistant', 'robotV2'].includes(route.name)) {
    return `solution > ${route.path.slice(1)}`
  }
  return null
}

export function installPageTracking(router, report) {
  return router.afterEach((to, from, failure) => {
    // hash / 筛选参数变化不算新的访问；取消和重复导航不计数。
    if (failure || to.path === from.path) return
    const position = getPageTrackPosition(to)
    if (position) void report({ position })
  })
}
